import React from 'react'
import Modal from '../shared/modal'
import { t } from '../../i18n'

interface Props {
  slotNumbers: number[];
  onConfirm: () => void;
  onCancel: () => void;
}

const DisableCookingUnitConfirmModal = ({ slotNumbers, onConfirm, onCancel }: Props) => (
  <Modal
    headerText={t('locations.kitchen_configuration.disable_confirm.heading')}
    onClose={onCancel}
  >
    <div className='mb-5'>
      {t('locations.kitchen_configuration.disable_confirm.body', { units: slotNumbers.join(', ') })}
    </div>
    <div className='d-flex gap-2'>
      <button className='btn btn-danger' onClick={onConfirm}>
        {t('locations.kitchen_configuration.disable_confirm.confirm')}
      </button>
      <button className='btn btn-secondary' onClick={onCancel}>
        {t('locations.kitchen_configuration.disable_confirm.cancel')}
      </button>
    </div>
  </Modal>
)

export default DisableCookingUnitConfirmModal
